import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setAskRedoSlackEnabled = {
  name: "setAskRedoSlackEnabled" as const,
  input: z.object({
    teamId: zExt.objectId(),
    enabled: z.boolean(),
    environmentKey: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
